import { createFileRoute } from '@tanstack/react-router'
import { ProductsListPage } from '../../../features/catalog/products-list-page'
import { productSearchSchema } from '../../../features/catalog/search'

export const Route = createFileRoute('/_app/products/')({
  validateSearch: productSearchSchema,
  component: ProductsListPage,
})
